<template>
  <div>
    <v-app-bar color="grey lighten-3" flat>
      <Logo />
      <v-spacer></v-spacer>
      <div v-if="$store.state.account.current">
        {{ $store.state.account.current.email }}
      </div>
      <v-btn
        v-if="$store.state.account.current"
        @click="signout"
        color="primary"
        class="ml-2"
        text
        >{{ $t("signout") }}
        <v-icon right small>{{ mdiExitToApp }}</v-icon>
      </v-btn>
      <template v-else>
        <v-btn
          @click="signin"
          outlined
          size="small"
          color="primary"
          class="mr-3"
        >
          {{ $t("signin") }}
        </v-btn>
        <v-btn @click="registration" text size="small" color="primary">{{
          $t("registration")
        }}</v-btn>
      </template>
    </v-app-bar>
    <LeftPanel @toogleDrawer="toogleDrawer" :drawer="drawer" />
  </div>
</template>

<script>
import Logo from "./Logo";
import LeftPanel from "./LeftPanel";
import { mdiExitToApp } from "@mdi/js";

export default {
  name: "Layout",
  components: {
    Logo,
    LeftPanel,
  },
  data: () => ({
    drawer: false,
    mdiExitToApp,
  }),
  methods: {
    signin() {
      this.$store.dispatch("authentication/toStep", "signin");
    },
    registration() {
      this.$store.dispatch("authentication/toStep", "registration");
    },
    signout() {
      this.$store.dispatch("authentication/signout");
    },
    toogleDrawer() {
      this.drawer = !this.drawer;
    },
  },
};
</script>
